import Booking from "@/components/site/Booking";

const Checkout = () => (
  <main className="pt-24 lg:pt-32">
    <Booking />
  </main>
);

export default Checkout;
